var base = 'https://linestogo.logika.net';

var delay = 100;
var defYear = '',
	defMake = '',
	defModel = '',
	defEngine = '',
	defCab = '',
	defBed = '',
	defPart = '';
var baseYears;
var fromVin = false;

var vpw = $(window).width();
var targetDiv = '#outerDiv';
if (vpw <= 860) targetDiv = '#results';

$(window).resize(function () {
	//location.reload();
});

$(function () {
	//{{{

	if (vpw <= 860) {
		$('html, body').animate(
			{
				// scrollTop: $('#outerDiv').offset().top,
			},
			1000
		);
	}

	var current_url = window.location.search;

	$.QueryString = (function (a) {
		if (a == '') return {};
		var b = {};
		for (var i = 0; i < a.length; ++i) {
			var p = a[i].split('=');
			if (p.length != 2) continue;
			b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, ' '));
		}
		return b;
	})(window.location.search.substr(1).split('&'));

	var qsVin = $.QueryString['vin'];
	if (typeof qsVin == 'string' && qsVin.length) {
		$('input#vin').val(qsVin);
		getResults();
	} else {
		var from = $.QueryString['from'];
		var fromCookie =
			typeof from == 'string' && from == 'cookie' ? true : false;
		var qsYear = $.QueryString['year'];
		if (fromCookie && (typeof qsYear != 'string' || !qsYear.length)) {
			qsYear = $.cookie('year');
		}
		if (typeof qsYear == 'string' && qsYear.length) {
			defYear = qsYear;
			var qsMake = $.QueryString['make'];
			if (fromCookie && (typeof qsMake != 'string' || !qsMake.length)) {
				qsMake = $.cookie('make');
			}
			if (typeof qsMake == 'string' && qsMake.length) {
				defMake = qsMake;
				var qsModel = $.QueryString['model'];
				if (
					fromCookie &&
					(typeof qsModel != 'string' || !qsModel.length)
				) {
					qsModel = $.cookie('model');
				}
				if (typeof qsModel == 'string' && qsModel.length) {
					defModel = qsModel;

					var qsEngine = $.QueryString['engine'];
					if (
						fromCookie &&
						(typeof qsEngine != 'string' || !qsEngine.length)
					) {
						qsEngine = $.cookie('engine');
					}
					if (typeof qsEngine == 'string' && qsEngine.length) {
						defEngine = qsEngine;
					}

					var qsCab = $.QueryString['cab'];
					if (
						fromCookie &&
						(typeof qsCab != 'string' || !qsCab.length)
					) {
						qsCab = $.cookie('cab');
					}
					if (typeof qsCab == 'string' && qsCab.length) {
						defCab = qsCab;
					}

					var qsBed = $.QueryString['bed'];
					if (
						fromCookie &&
						(typeof qsBed != 'string' || !qsBed.length)
					) {
						qsBed = $.cookie('bed');
					}
					if (typeof qsBed == 'string' && qsBed.length) {
						defBed = qsBed;
					}

					var qsPart = $.QueryString['part'];
					from;
					if (
						fromCookie &&
						(typeof qsPart != 'string' || !qsPart.length)
					) {
						qsPart = $.cookie('part');
					}
					if (typeof qsPart == 'string' && qsPart.length) {
						defPart = qsPart;
					}
				}
			}
		}

		$.getJSON(base + '/ajax/years?callback=?', {}, function (j) {
			baseYears = j;
			setYears(j);
			if (defYear.length) {
				$('select#year').select2('close');
				$.getJSON(
					base + '/ajax/makes?callback=?',
					{ year: $('select#year').val() },
					function (j) {
						setMakes(j);
						if (defMake.length) {
							$('select#make').select2('close');
							$.getJSON(
								base + '/ajax/models?callback=?',
								{
									year: $('select#year').val(),
									make: $('select#make').val(),
								},
								function (j) {
									setModels(j);
									if (defModel.length) {
										$('select#model').select2('close');
										if (
											defEngine.length ||
											defCab.length ||
											defBed.length
										) {
											$.getJSON(
												base +
													'/ajax/products?shopify=1&callback=?',
												{
													year: $(
														'select#year'
													).val(),
													make: $(
														'select#make'
													).val(),
													model: $(
														'select#model'
													).val(),
													engine: defEngine.length
														? defEngine
														: '',
													cab: defCab.length
														? defCab
														: '',
													bed: defBed.length
														? defBed
														: '',
												},
												function (j) {
													if (
														j.engines !==
															undefined &&
														j.engines.length
													)
														setEngines(j.engines);
													else setEngines();
													if (
														j.cabs !== undefined &&
														j.cabs.length
													)
														setCabs(j.cabs);
													else setCabs();
													if (
														j.beds !== undefined &&
														j.beds.length
													)
														setBeds(j.beds);
													else setBeds();

													getResults();
													defModel =
														defEngine =
														defCab =
														defBed =
														defPart =
															'';
												}
											);
										} else {
											getResults();
											defModel =
												defEngine =
												defCab =
												defBed =
												defPart =
													'';
										}
									}
								}
							).fail(function () {
								setModels();
								setEngines();
								setCabs();
								setBeds();
								setParts();
								defModel =
									defEngine =
									defCab =
									defBed =
									defPart =
										'';
							});
						} else {
							setModels();
							setEngines();
							setCabs();
							setBeds();
							setParts();
						}
						defMake = '';
					}
				).fail(function () {
					setMakes();
					setModels();
					setEngines();
					setCabs();
					setBeds();
					setParts();
					defMake =
						defModel =
						defEngine =
						defCab =
						defBed =
						defPart =
							'';
				});
			} else {
				setMakes();
				setModels();
				setEngines();
				setCabs();
				setBeds();
				setParts();
			}
			defYear = '';
		}).fail(function () {
			setYears();
			setMakes();
			setModels();
			setEngines();
			setCabs();
			setBeds();
			setParts();
			defYear =
				defMake =
				defModel =
				defEngine =
				defCab =
				defBed =
				defPart =
					'';
		});
	}

	$('select#year').change(function () {
		$('input#vin').val('');
		if ($(this).val().length) {
			setTimeout(function () {
				$.getJSON(
					base + '/ajax/makes?callback=?',
					{ year: $('select#year').val() },
					function (j) {
						setMakes(j);
						setModels();
						setEngines();
						setCabs();
						setBeds();
						setParts();
						$('select#make').select2('enable', true);
						$('select#model').select2('enable', false);
						$('select#engine').select2('enable', false);
						$('select#cab').select2('enable', false);
						$('select#bed').select2('enable', false);
						$('select#part').select2('enable', false);
					}
				);
			}, delay);
		} else {
			setMakes();
			setModels();
			setEngines();
			setCabs();
			setBeds();
			setParts();
			$('select#make').select2('enable', false);
			$('select#model').select2('enable', false);
			$('select#engine').select2('enable', false);
			$('select#cab').select2('enable', false);
			$('select#bed').select2('enable', false);
			$('select#part').select2('enable', false);
		}
	});

	$('select#make').change(function () {
		$('input#vin').val('');
		if ($(this).val().length) {
			setTimeout(function () {
				$.getJSON(
					base + '/ajax/models?callback=?',
					{
						year: $('select#year').val(),
						make: $('select#make').val(),
					},
					function (j) {
						setModels(j);
						setEngines();
						setCabs();
						setBeds();
						setParts();
						$('select#model').select2('enable', true);
						$('select#engine').select2('enable', false);
						$('select#cab').select2('enable', false);
						$('select#bed').select2('enable', false);
						$('select#part').select2('enable', false);
					}
				);
			}, delay);
		} else {
			setModels();
			setEngines();
			setCabs();
			setBeds();
			setParts();
			$('select#model').select2('enable', false);
			$('select#engine').select2('enable', false);
			$('select#cab').select2('enable', false);
			$('select#bed').select2('enable', false);
			$('select#part').select2('enable', false);
		}
	});

	$('select#model').change(function () {
		$('input#vin').val('');
		setEngines();
		setCabs();
		setBeds();
		setParts();
		if ($(this).val().length) {
			getResults();
		} else {
			$('select#engine').select2('enable', false);
			$('select#cab').select2('enable', false);
			$('select#bed').select2('enable', false);
			$('select#part').select2('enable', false);
		}
	});

	$('select#engine').change(function () {
		$('input#vin').val('');
		getResults();
	});

	$('select#cab').change(function () {
		$('input#vin').val('');
		getResults();
	});

	$('select#bed').change(function () {
		$('input#vin').val('');
		getResults();
	});

	$('select#part').change(function () {
		$('input#vin').val('');
		getResults();
	});

	$('input#reset').click(function () {
		history.pushState(null, null, '/pages/product-finder/');
		$('input#vin').val('');
		setYears(baseYears);
		setMakes();
		setModels();
		setEngines();
		setCabs();
		setBeds();
		setParts();
		$('select#make').select2('enable', false);
		$('select#model').select2('enable', false);
		$('select#engine').select2('enable', false);
		$('select#cab').select2('enable', false);
		$('select#bed').select2('enable', false);
		$('select#part').select2('enable', false);
		$('div#results').html('');
	});
}); //}}}
function safe(text) {
	//{{{
	if (text !== null)
		return text
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#039;');
	else return '';
} //}}}
function setYears(j) {
	//{{{
	var options = '<option value="">Year</option>';
	for (var i = 0; i < (typeof j == 'undefined' ? 0 : j.length); i++) {
		var selected = j[i] == defYear && defYear != '' ? ' selected' : '';
		options +=
			'<option value="' +
			j[i] +
			'"' +
			selected +
			'>' +
			safe(j[i]) +
			'</option>';
	}
	$('select#year').html(options);
	$('select#year').select2({ minimumResultsForSearch: 5 });
	// if (typeof j != 'undefined') $('select#year').select2('open');
} //}}}
function setMakes(j) {
	//{{{
	var options = '<option value="">Select a Make</option>';
	var cnt = 0;
	for (var i = 0; i < (typeof j == 'undefined' ? 0 : j.length); i++) {
		var selected = j[i] == defMake && defMake != '' ? ' selected' : '';
		options +=
			'<option value="' +
			j[i] +
			'"' +
			selected +
			'>' +
			safe(j[i]) +
			'</option>';
		cnt++;
	}
	$('select#make').html(options);
	$('select#make').attr('disabled', cnt ? false : true);
	$('select#make').select2({ minimumResultsForSearch: 5 });
	// if (typeof j != 'undefined') $('select#make').select2('open');
} //}}}
function setModels(j) {
	//{{{
	var options = '<option value="">Select a Model</option>';
	var cnt = 0;
	for (var i = 0; i < (typeof j == 'undefined' ? 0 : j.length); i++) {
		var selected = j[i] == defModel && defModel != '' ? ' selected' : '';
		options +=
			'<option value="' +
			j[i] +
			'"' +
			selected +
			'>' +
			safe(j[i]) +
			'</option>';
		cnt++;
	}
	$('select#model').html(options);
	$('select#model').attr('disabled', cnt ? false : true);
	$('select#model').select2({ minimumResultsForSearch: 5 });
	// if (typeof j != 'undefined') $('select#model').select2('open');
} //}}}
function setEngines(j) {
	//{{{
	var options = '<option value="">Select an Engine</option>';
	var cnt = 0;
	for (var i = 0; i < (typeof j == 'undefined' ? 0 : j.length); i++) {
		var selected = j[i] == defEngine && defEngine != '' ? ' selected' : '';
		if (safe(j[i]) !== 'Not Applicable') {
			//Skip adding to drop down
			options +=
				'<option value="' +
				j[i] +
				'"' +
				selected +
				'>' +
				safe(j[i]) +
				'</option>';
			cnt++;
		}
	}
	$('select#engine').html(options);
	$('select#engine').attr('disabled', cnt ? false : true);
	$('select#engine').select2({ minimumResultsForSearch: 5 });
} //}}}
function setCabs(j) {
	//{{{
	var options = '<option value="">Select a Cab Configuration</option>';
	var cnt = 0;
	for (var i = 0; i < (typeof j == 'undefined' ? 0 : j.length); i++) {
		var selected = j[i] == defCab && defCab != '' ? ' selected' : '';
		if (safe(j[i]) !== 'Not Applicable') {
			//Skip adding to drop down
			options +=
				'<option value="' +
				j[i].replace(/"/g, '&quot;') +
				'"' +
				selected +
				'>' +
				safe(j[i]) +
				'</option>';
			cnt++;
		}
	}
	$('select#cab').html(options);
	$('select#cab').attr('disabled', cnt ? false : true);
	$('select#cab').select2({ minimumResultsForSearch: 5 });
} //}}}
function setBeds(j) {
	//{{{
	var options = '<option value="">Select a Bed Length</option>';
	var cnt = 0;
	for (var i = 0; i < (typeof j == 'undefined' ? 0 : j.length); i++) {
		var selected = j[i] == defBed && defBed != '' ? ' selected' : '';
		if (safe(j[i]) !== 'Not Applicable') {
			//Skip adding to drop down
			options +=
				'<option value="' +
				j[i].replace(/"/g, '&quot;') +
				'"' +
				selected +
				'>' +
				safe(j[i]) +
				'</option>';
			cnt++;
		}
	}
	$('select#bed').html(options);
	$('select#bed').attr('disabled', cnt ? false : true);
	$('select#bed').select2({ minimumResultsForSearch: 5 });
} //}}}
function setParts(j) {
	//{{{
	var options = '<option value="">Select an Application</option>';
	var cnt = 0;
	for (var i = 0; i < (typeof j == 'undefined' ? 0 : j.length); i++) {
		var selected = j[i] == defPart && defPart != '' ? ' selected' : '';
		if (safe(j[i]) !== 'Not Applicable') {
			//Skip adding to drop down
			options +=
				'<option value="' +
				j[i].replace(/"/g, '&quot;') +
				'"' +
				selected +
				'>' +
				safe(j[i]) +
				'</option>';
			cnt++;
		}
	}
	$('select#part').html(options);
	$('select#part').attr('disabled', cnt ? false : true);
	$('select#part').select2({ minimumResultsForSearch: 5 });
} //}}}
function setPartsOld() {
	//{{{
	var options = '<option value="">Select an Application</option>';
	options += '<option value="Fuel">Fuel Lines</option>';
	options += '<option value="Brake">Brake Lines</option>';
	$('select#part').html(options);
	$('select#part').attr('disabled', false);
	$('select#part').select2({ minimumResultsForSearch: 5 });
} //}}}
function getResults() {
	//{{{
	if (
		($('input#vin').length && $('input#vin').val().length) ||
		($('select#year').val().length &&
			$('select#make').val().length &&
			$('select#model').val().length)
	) {
		$.cookie('year', $('select#year').val(), { path: '/' });
		$.cookie('make', $('select#make').val(), { path: '/' });
		$.cookie('model', $('select#model').val(), { path: '/' });
		$.cookie('engine', $('select#engine').val(), { path: '/' });
		$.cookie('cab', $('select#cab').val(), { path: '/' });
		$.cookie('bed', $('select#bed').val(), { path: '/' });

		if ($('input#vin').length && $('input#vin').val().length) {
			fromVin = true;
		} else {
			fromVin = false;
		}

		setTimeout(function () {
			//Legacy for BC
			/*
      var currency_id = $("#currencySelection").attr("value");
	  if(typeof currency_id == "undefined" || currency_id.length <= 0)
	    currency_id = "";
	  if(currency_id == "2")
	    currency_id = "8"; //temporary?  sandbox site canadian set to 2
      */

			//New for Shopify
			var exchange_rate = '1';
            var currency = '';
			if ( typeof Shopify !== 'undefined' && typeof Shopify.currency !== 'undefined' && typeof Shopify.currency.rate !== 'undefined')
				exchange_rate = Shopify.currency.rate;                
			if ( typeof Shopify !== 'undefined' && typeof Shopify.currency !== 'undefined' && typeof Shopify.currency.active !== 'undefined')
		       currency = Shopify.currency.active;               
          
			var newURL =
				'/pages/product-finder/?year=' +
				$('select#year').val() +
				'&make=' +
				$('select#make').val() +
				'&model=' +
				$('select#model').val() +
				'&engine=' +
				$('select#engine').val() +
				'&cab=' +
				$('select#cab').val() +
				'&bed=' +
				$('select#bed').val();
			history.pushState(null, null, newURL);

			$.getJSON(
				base + '/ajax/products?shopify=1&callback=?',
				{
					vin: $('input#vin').val(),
					year: $('select#year').val(),
					make: $('select#make').val(),
					model: $('select#model').val(),
					engine: $('select#engine').val(),
					cab: $('select#cab').val(),
					bed: $('select#bed').val(),
					part: $('selec0t#part').val(),
					exchange: exchange_rate,
                    currency: currency
				},
				function (j) {

					// [Start] PostHog Search Tracking
                    if (window.posthog) {
                        var resCount = (j.products && j.products.length) ? j.products.length : 0;
                        posthog.capture('product_finder_search', {
                            vehicle_year: $('select#year').val(),
                            vehicle_make: $('select#make').val(),
                            vehicle_model: $('select#model').val(),
                            vehicle_vin: $('input#vin').val(), // Critical if they searched by VIN
                            result_count: resCount,
                            has_results: resCount > 0
                        });
                    }
                    // [End] PostHog Search Tracking

					var lastCart = true;
					var extra = '';
					if (j.engines != null) {
						defEngine = $('select#engine').val();
						setEngines(j.engines);
					}
					if (j.cabs != null) {
						defCab = $('select#cab').val();
						setCabs(j.cabs);
					}
					if (j.beds != null) {
						defBed = $('select#bed').val();
						setBeds(j.beds);
					}
					if (j.parts != null) {
						defPart = $('select#part').val();
						setParts(j.parts);
					}
					if (j.year != null && j.years != null) {
						defYear = j.year;
						setYears(j.years);
						//setMakes();
						//setModels();
						//setEngines();
						//setCabs();
						//setBeds();
						//setParts();
						extra = j.year;
						$('select#year').select2('close');

						if (j.make != null && j.makes != null) {
							defMake = j.make;
							setMakes(j.makes);
							extra += ' ' + j.make;
							$('select#make').select2('close');

							if (j.model != null && j.models != null) {
								defModel = j.model;
								setModels(j.models);
								extra += ' ' + j.model;
								$('select#model').select2('close');

								if (
									j.engine != null &&
									j.engine.length &&
									j.engines != null
								) {
									defEngine = j.engine;
									setEngines(j.engines);
									extra += ' ' + j.engine;
									$('select#engine').select2('close');
								}

								setCabs(j.cabs);
								setBeds(j.beds);
								setParts(j.parts);
							}
						}
					}
					var buf =
						'<table id="results" style="width:100%; table-layout:unset;">' +
						'<tr>' +
						'<th id="ttlSpecification">Specification</th>' +
						'<th id="ttlApplication">Application</th>' +
						'<th id="ttlEngine">Engine</th>' +
						//'<th id="ttlLocation">Location</th>' +
						'<th id="ttlPartNbr">Part Number</th>' +
						'<th id="ttlImage">Image</th>' +
						'<th id="ttlImage">Price</th>' +
						'<th id="ttlComment">Parts Included</th>' +
						'</tr>';

					if (j.products.length > 0) {
						for (var i = 0; i < j.products.length; i++) {
							if (j.products[i].product == false) {
								buf +=
									'<tr>' +
									'<td class="resSpecification">' +
									safe(j.products[i].specification) +
									'</td>' +									
									'<td class="resApplication">' +
									safe(j.products[i].application) +
									'</td>' +
									'<td class="resEngine">' +
									safe(j.products[i].engine) +
									(j.testing && j.products[i].cab.length
										? '; ' + safe(j.products[i].cab)
										: '') +
									(j.testing && j.products[i].bed.length
										? '; ' + safe(j.products[i].bed)
										: '') +
									(j.testing && j.products[i].app.length
										? '; ' + safe(j.products[i].app)
										: '') +
									(j.testing && j.products[i].row.length
										? '; (' + safe(j.products[i].row) + ')'
										: '') +
									'</td>' +
									//'<td class="resLocation">' +
									//safe(j.products[i].location) +
									//'</td>' +
									'<td class="resPartNbr"><a href="/products/' +
									safe(j.products[i].id) +
									'from=productfinder">' +
									safe(j.products[i].id) +
									'</a></td>' +
									'<td class="resImage">&nbsp;</td>' +
									'<td class="resPrice">&nbsp;</td>' +
									'<td class="resComment">' +
									safe(j.products[i].comment) +
									'</td>' +
									'</tr>';
							} else {
								//var image_link = 'https://cdn1.bigcommerce.com/server600/84388/products/'+j.products[i].product.id+'/images/'+j.products[i].product.thumb_id+'/'+j.products[i].product.thumb_name+'.1403796813.190.285.jpg';
                                var rawPrice = j.products[i].product.price.toFixed(2);
                                var formattedPrice = formatShippingAmount(rawPrice);
                                
								buf +=
									'<tr>' +
									'<td class="resSpecification">' +
									safe(j.products[i].specification) +
									'</td>' +									
									'<td class="resApplication">' +
									safe(j.products[i].application) +
									'</td>' +
									'<td class="resEngine">' +
									safe(j.products[i].engine) +
									(j.testing && j.products[i].cab.length
										? '; ' + safe(j.products[i].cab)
										: '') +
									(j.testing && j.products[i].bed.length
										? '; ' + safe(j.products[i].bed)
										: '') +
									(j.testing && j.products[i].app.length
										? '; ' + safe(j.products[i].app)
										: '') +
									(j.testing && j.products[i].row.length
										? '; (' + safe(j.products[i].row) + ')'
										: '') +
									'</td>' +
									//'<td class="resLocation">' +
									//safe(j.products[i].location) +
									//'</td>' +
									'<td class="resPartNbr"><a href="/products/' +
									safe(j.products[i].product.url) +
									'?from=productfinder">' +
									safe(j.products[i].id) +
									'</a></td>' +
									'<td class="resImage"><img style="max-width:200px;" src="' +
									safe(j.products[i].product.image) +
									'" alt="" border=0></td>' +
									//'<td class="resPrice">$' +
                                    '<td class="resPrice">' +
									//j.products[i].product.price.toFixed(2) +
									formattedPrice +
                                    '</td>' +
									'<td class="resComment">' +
									safe(j.products[i].comment) +
									'</td>' +
									'</tr>';
							}

							lastCart = j.products[i].id;
						}

						buf += '</table>';

						if (fromVin) {
							if (typeof $.cookie('fromVin') == 'undefined') {
								//From VIN, session cookie not present, show notification
								$.cookie('fromVin', '1', { path: '/' });
								showVinMsg();
							}
						}
					} else {
						var byYMM = '. Please contact us.';
						//if(location.href.indexOf("?vin=") >= 0)
						if ($('input#vin').val() !== '')
							byYMM =
								'. Please try a lookup by Year/Make/Model or contact us.';

						if (extra.length && extra.indexOf('NA NA NA') >= 0)
							//unable to determine vehicle by VIN, don't display (NA NA NA).
							extra = 'Unable to translate VIN';

						buf =
							'<div id="noresults">No products available for the selected vehicle' +
							(extra.length ? ' (' + extra + ')' : '') +
							byYMM +
							'</div>';
					}
					$('div#results').html(buf);
					$('html, body').animate(
						{
							// scrollTop: $(targetDiv).offset().top,
						},
						1000
					);
					defYear =
						defMake =
						defModel =
						defEngine =
						defCab =
						defBed =
						defPart =
							'';
				}
			)
				.fail(function () {})
				.always(function () {});
		}, delay);
	}
	return false;
} //}}}
function clearForm() {
	//{{{
	$.cookie('year', '', { path: '/' });
	$.cookie('make', '', { path: '/' });
	$.cookie('model', '', { path: '/' });
	$.cookie('engine', '', { path: '/' });
	$.cookie('bed', '', { path: '/' });
	$.cookie('cab', '', { path: '/' });

	$('input#vin').val('');
	$.getJSON(base + '/ajax/years?callback=?', {}, function (j) {
		baseYears = j;
		setYears(j);
		//setYears(baseYears);
		setMakes();
		setModels();
		setEngines();
		setCabs();
		setBeds();
		setParts();
	}).fail(function () {
		setYears();
		setMakes();
		setModels();
		setEngines();
		setCabs();
		setBeds();
		setParts();
	});
	$('div#results').html('');
	history.pushState(null, null, '/pages/product-finder/');

	//also delete cookie
	$.removeCookie('year', { path: '/' });
	$.removeCookie('make', { path: '/' });
	$.removeCookie('model', { path: '/' });
	$.removeCookie('engine', { path: '/' });
	$.removeCookie('bed', { path: '/' });
	$.removeCookie('cab', { path: '/' });

	return false;
} //}}}

function showVinMsg() {
	$('#pfVinAlert')
		.modal({
			useFlex: false,
		})
		.modal('show');
}

//note, there is a duplicate of this funciton in ship-v2.js as well that if changes are made need to be done in both locations
function formatShippingAmount(amount) {

  // Use a regular expression to find the placeholder in ship_money_format.
  // This regex finds the text between double curly braces.
  var placeholderMatch = ship_money_format.match(/{{\s*(.*?)\s*}}/);

  var placeholder = placeholderMatch[1]; // e.g., "amount" or "amount_with_comma_separator"
  var formattedAmount;

  // If no placeholder is found, default to us/ca (not that it matters, just set to something since we are checking for EU style below, and all else is us/ca style)
  if (!placeholderMatch) {
    placeholder = "amount";
  }

  // Format the amount based on the placeholder.
  if (placeholder === "amount_with_comma_separator") {
    // European style: Using the 'de-DE' locale converts 1234.56 to "1.234,56"
    formattedAmount = new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  } else {
    // North American style, e.g. "1,234.56"
    formattedAmount = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);

  }
  // Replace the placeholder (including the braces) with the formatted number.
  var result = ship_money_format.replace(/{{\s*.*?\s*}}/, formattedAmount);
  return result;

}
